import { render } from "./ztn-cancel-button.vue?vue&type=template&id=0558ae64&scoped=true"
import script from "./ztn-cancel-button.vue?vue&type=script&lang=js"
export * from "./ztn-cancel-button.vue?vue&type=script&lang=js"

import "./ztn-cancel-button.vue?vue&type=style&index=0&id=0558ae64&scoped=true&lang=css"

import exportComponent from "/src/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@4.8.4__webpack@5.84.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0558ae64"]])

export default __exports__